import { cap } from '../../../State'
import { translations } from '../../../translations'
import { statoCard } from './Functions'

const language = cap.language.state || 'IT'
const t = translations[language] || translations.IT

/**
 * Stato di una card così come lo calcola il server (09 §9.4): badge, motivi e
 * ultima modifica. Il Web non ricalcola `readiness`.
 * @param {Object} props - Proprietà
 * @param {Object} props.card - `NoraConfigurationCard`
 * @returns {import('react').JSX.Element}
 */
export const StatoCard = ({ card }) => {
  const { label, badge } = statoCard(card.readiness, t)
  return (
    <div style={{ display: 'grid', gap: 4 }} data-testid="cn-stato-card">
      <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
        <span className={`nbadge ${badge}`}>{label}</span>
        <span style={{ fontSize: 12, color: 'var(--ink-500)' }}>
          {t.cnAggiornataIl} {new Date(card.updatedAt).toLocaleString()}
          {card.updatedBy ? ` · ${card.updatedBy}` : ''}
        </span>
      </div>
      {!!card.reasons?.length && (
        <ul style={{ margin: 0, paddingLeft: 18, fontSize: 12, color: 'var(--ink-700)' }}>
          {card.reasons.map((motivo) => (
            <li key={motivo}>{motivo}</li>
          ))}
        </ul>
      )}
    </div>
  )
}

export default StatoCard
